import { useEffect } from "react";
import { useHome } from "../../../../hooks/useHome"
import { pathImages, pathPDF } from "../../../../routes/endpoints";
import { Link } from "react-router-dom";
import { ImageCarouselMobile } from "./ImageCarouselMobile";

export const ImageCarousel = () => {
    const { carruselImages, getCarrusel } = useHome();

    useEffect(() => {
        getCarrusel();
    }, [])

    return (
        <>
            <div className="row mostrarBanEscritorio" role="article" aria-label="sitio de interés">
                <div className="col-12 px-0">
                    <div id="BanDesktop" className="carousel slide">
                        <div className="carousel-inner">
                            {carruselImages?.map(({ id, imagen, url, archivo, titulo }, i) => (
                                <div key={id} className={`carousel-item ${i === 0 ? "active" : ""}`}>
                                    {url || archivo ?
                                        <Link to={url || `${pathPDF}${archivo}`} target="_blank" role="link" aria-label={`${titulo}`}>
                                            <img src={`${pathImages}${imagen}`} alt="" className="banner" />
                                        </Link>
                                        :
                                        <img src={`${pathImages}${imagen}`} alt="" className="banner" />
                                    }
                                </div>
                            ))}
                        </div> 
                        <button className="carousel-control-prev" type="button" data-bs-target="#BanDesktop" data-bs-slide="prev" role="button" aria-label="imagen anterior">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#BanDesktop" data-bs-slide="next" role="button" aria-label="imagen siguiente">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                </div>
            </div>

            <ImageCarouselMobile images={carruselImages} />
        </>
    )
}
